import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

import { Box } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { useSelector } from 'react-redux';
import robot from '../../assets/robot.PNG';
import { isMobile } from "react-device-detect";
import { useHttp } from '../../hooks/httpHook';

const useStyles = makeStyles((theme) => ({
    customImageView: {
        color: "transparent",
        width: "100%",
        height: "100%",
        objectFit: "contain",
        textAlign: "center",
        textIndent: "10000px"
    },

    card: {
        borderRadius: '20px',
        marginLeft: isMobile ? 20 : 30,
        marginTop: isMobile ? 23 : 30,
        borderColor: '#E3EFFE',
        minWidth: isMobile ? 335 : 434,
        minHeight: isMobile ? 290 : 254,
        maxWidth: isMobile ? 335 : 434,
        maxHeight: isMobile ? 290 : 254,
        color: '#162946',
    },
    chip: {
        borderRadius: '3px',
        //margin: theme.spacing(1),
        backgroundColor: '#E3EFFE',
        color: '#9FAABC',
        paddingLeft: 12,
        margin: 8,
        textAlign: 'center',
    },
    divider: {
        marginTop: -5,
        backgroundColor: '#E3EFFE'
    },
    onsite: {
        marginTop: -3,
        color: '#9FAABC'
    },
    salary: {
        fontSize: 18,
        color: '#162946'
    },
    chipBox1: {
        marginTop: 12,
        maxHeight: 72,
    },
    chipBox2: {
        marginTop: -10
    },
    fallback: {
        margin: 0,
        minHeight: 55,
        maxHeight: 55,
        minWidth: 55,
        maxWidth: 55,
        backgroundColor: '#fff'
    }
}));

export default function VacancyCard(props) {
    const classes = useStyles();
    const stack = useSelector((state) => state.filterReducer.stack);
    const { request } = useHttp();

    const numberFormat = (value) =>
        new Intl.NumberFormat('ru-RU', {
            useGrouping: true,
        }).format(value);

    const getChipColor = (val) => {
        if(!stack){
            return;
        }
        for (let i = 0; i < stack.length; i++) {
            if (stack[i].name === val) {
                return '#E3EFFE';
            }
        }
        return '#FAFAFA'
    };

    const getTextColor = (val) => {
        if(!stack){
            return;
        }
        for (let i = 0; i < stack.length; i++) {
            if (stack[i].name === val) {
                return '#3C70F1';

            }
        }
        return '#9FAABC'
    };

    const experiences = useSelector((state) => state.clsReducer.experiences);

    const getExperiencesById = (id) => {
        for (let i = 0; i < experiences.length; i++) {
            if (experiences[i].id === id) {
                return experiences[i].name;
            }
        }
    }

    const getJobKind = (val) => {
        switch (val) {
            case 1: {
                return 'В офисе';
            }

            case 2: {
                return 'Удалённо';
            }

            case 3: {
                return 'В офисе или удаленно';
            }

            default: {
                return 'В офисе или удаленно';
            }
        }
    }

    const goToVacancy = (val) => {
        window.open(
            "https://app.headz.io/vacancies/" + val.id,
            '_blank'
        );
    };
    const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }

    return (
        <Card className={classes.card} variant="outlined" onClick={() => goToVacancy(props.value)} >
            <CardHeader
                avatar={
                    <Avatar variant="square" aria-label="recipe" sx={{  height: 55, width: 55 }}
                        style={{
                            margin: "0px",
                            width: "55px",
                            minHeight: "55px"
                        }} className = {classes.customImageView}
                        src={`https://api.headz.io/api/image?eid=${props.value.employer_id}`} >
                        <Avatar  variant="square" aria-label="recipe" sx={{ width: 55, height: 55 }} className={classes.fallback}
                            style={{
                                margin: "0px",
                                width: "55px",
                                height: "55px"
                            }}
                            src={robot} />
                        </Avatar>
                }
                        title={props.value.name}
                        subheader={props.value.company_name}
            />
                        <Divider className={classes.divider} />
                        <CardContent>
                            <Typography variant="h6"  component="p" className={classes.onsite}>
                                {getJobKind(props.value.job_kind_id)}
                            </Typography>
                            <Typography variant="h6" color="#162946" component="p" className={classes.salary}>
                                <b>{!props.value.min || props.value.hide_salary ? "" : numberFormat(props.value.min) + " – " + numberFormat(props.value.max) } {!props.value.hide_salary && props.value.currency_code? props.value.currency_code + "/мес." : " " }</b>
                            </Typography>
                            <Box className={classes.chipBox1} overflow="hidden">
                                {props.value.experience_ids.map((item, index) => (
                                    <Chip key={index} className={classes.chip} size="small" label={getExperiencesById(item)} style={{ marginLeft: 0, marginBottom: 0, backgroundColor: getChipColor(getExperiencesById(item)), color: getTextColor(getExperiencesById(item)) }} />
                                ))}
                            </Box>
                        </CardContent>

        </Card>
    );
}
